import { Link, NavLink } from 'react-router-dom';
import { useEffect, useState } from 'react';

const NAV_BASE = {
  position: 'sticky',
  top: 0,
  zIndex: 50,
  width: '100%',
  transition: 'background 0.2s ease, box-shadow 0.2s ease',
};

const INNER = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '14px 0',
};

const BRAND = {
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  fontFamily: "'Baloo 2', sans-serif",
  fontWeight: 800,
  fontSize: '1.4rem',
  color: 'var(--ink)',
};

const ICON_WRAP = {
  width: 38,
  height: 38,
  borderRadius: 10,
  background: 'linear-gradient(180deg, #6EC6F5 0%, #7C3AED 100%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  boxShadow: '0 4px 0 rgba(124, 58, 237, 0.3)',
};

const LINK_BASE = {
  color: 'var(--ink-soft)',
  textDecoration: 'none',
  padding: '6px 0',
  fontWeight: 600,
  fontSize: '0.95rem',
  position: 'relative',
};

const LINK_ACTIVE = {
  color: 'var(--sky-bot)',
};

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Transparent over the hero, solid white once scrolled — keeps the
  // hero clean while staying readable on every other page.
  const headerStyle = {
    ...NAV_BASE,
    background: scrolled ? 'rgba(255, 255, 255, 0.92)' : 'transparent',
    backdropFilter: scrolled ? 'blur(12px)' : 'none',
    WebkitBackdropFilter: scrolled ? 'blur(12px)' : 'none',
    boxShadow: scrolled ? '0 1px 0 rgba(15, 23, 42, 0.08)' : 'none',
  };

  return (
    <header style={headerStyle}>
      <div className="container" style={INNER}>
        <Link to="/" style={BRAND} onClick={() => setOpen(false)}>
          <span style={ICON_WRAP}>
            <img src="/guessup-icon-fg.png" alt="" width="34" height="34" style={{ display: 'block' }} />
          </span>
          GuessUp
        </Link>

        <nav className="nav-desktop" style={{ display: 'none', alignItems: 'center', gap: 28 }}>
          <NavLink to="/" end style={({ isActive }) => ({ ...LINK_BASE, ...(isActive ? LINK_ACTIVE : {}) })}>Home</NavLink>
          <a href="/#features" style={LINK_BASE}>Features</a>
          <a href="/#how-it-works" style={LINK_BASE}>How it works</a>
          <NavLink to="/contact" style={({ isActive }) => ({ ...LINK_BASE, ...(isActive ? LINK_ACTIVE : {}) })}>Contact</NavLink>
          <a href="/#download" className="btn-3d purple" style={{ padding: '10px 22px', fontSize: '0.92rem', boxShadow: '0 4px 0 #5B21B6' }}>
            Download
          </a>
        </nav>

        <button
          aria-label="Toggle menu"
          onClick={() => setOpen(!open)}
          className="nav-burger"
          style={{
            width: 42, height: 42, borderRadius: 12,
            background: 'rgba(15, 23, 42, 0.06)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
        >
          <span style={{
            display: 'block', width: 18, height: 2,
            background: 'var(--ink)', borderRadius: 2,
            boxShadow: '0 -6px 0 var(--ink), 0 6px 0 var(--ink)',
          }} />
        </button>
      </div>

      {open && (
        <div className="nav-mobile" style={{
          background: 'white',
          borderTop: '1px solid var(--line)',
          padding: '8px 24px 18px',
        }}>
          <NavLink to="/" end onClick={() => setOpen(false)} style={{ display: 'block', padding: '12px 0', color: 'var(--ink-soft)', fontWeight: 600 }}>Home</NavLink>
          <a href="/#features" onClick={() => setOpen(false)} style={{ display: 'block', padding: '12px 0', color: 'var(--ink-soft)', fontWeight: 600 }}>Features</a>
          <a href="/#how-it-works" onClick={() => setOpen(false)} style={{ display: 'block', padding: '12px 0', color: 'var(--ink-soft)', fontWeight: 600 }}>How it works</a>
          <NavLink to="/contact" onClick={() => setOpen(false)} style={{ display: 'block', padding: '12px 0', color: 'var(--ink-soft)', fontWeight: 600 }}>Contact</NavLink>
          <a href="/#download" onClick={() => setOpen(false)} className="btn-3d purple" style={{ marginTop: 12, width: '100%' }}>
            Download
          </a>
        </div>
      )}

      <style>{`
        @media (min-width: 720px) {
          .nav-desktop { display: flex !important; }
          .nav-burger { display: none !important; }
          .nav-mobile { display: none !important; }
        }
      `}</style>
    </header>
  );
}
